import { Link } from 'react-router-dom';

const BlogSection = () => {
  const posts = [
    {
      id: 1,
      title: 'Serengeti Bytes Announces The Third Season Of The Tanzania Digital Awards',
      excerpt: '',
      image: '/assets/webpage/TDA2024_182.jpg',
      date: 'December 13, 2022',
      readTime: '15 min read',
      slug: 'tda-third-season-announcement'
    },
    {
      id: 2,
      title: 'Serengeti Bytes Yatangaza Msimu Wa Tatu Wa Tuzo Za Kidigitali Tanzania',
      excerpt: '',
      image: '/assets/webpage/8.jpg',
      date: 'December 13, 2022',
      readTime: '15 min read',
      slug: 'tda-msimu-wa-tatu'
    }
  ];

  return (
    <section 
      className="py-12 md:py-24 relative overflow-hidden" 
      style={{ 
        backgroundColor: '#0a0e27',
        padding: '3rem 0',
        position: 'relative',
        overflow: 'hidden'
      }}
    >
      {/* Background pattern */}
      <div 
        style={{
          position: 'absolute',
          top: 0,
          right: 0,
          bottom: 0,
          width: '50%',
          background: 'repeating-linear-gradient(45deg, transparent, transparent 10px, rgba(255,255,255,0.02) 10px, rgba(255,255,255,0.02) 20px)',
          pointerEvents: 'none'
        }}
      ></div>

      <div 
        className="container mx-auto px-4 relative z-10 flex justify-center" 
        style={{ maxWidth: '1200px', position: 'relative', zIndex: 10, display: 'flex', justifyContent: 'center' }}
      >
        <div className="w-full max-w-5xl">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-start">
            
            {/* Left Column - Header */}
            <div className="text-left">
              <span 
                className="text-gray-400 font-medium text-sm uppercase tracking-wider block mb-4" 
                style={{ 
                  color: '#9ca3af', 
                  fontSize: '0.875rem',
                  letterSpacing: '0.1em',
                  marginBottom: '1rem',
                  marginLeft: '20px',
                  textAlign: 'left'
                }}
              >
                LATEST NEWS
              </span>
              
              <h2 
                className="text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-4 md:mb-6 leading-tight" 
                style={{ 
                  fontSize: 'clamp(1.5rem, 2.5vw, 2.5rem)',
                  fontWeight: '700', 
                  color: 'white',
                  marginBottom: '1rem',
                  marginLeft: '20px',
                  lineHeight: '1.2',
                  textAlign: 'left'
                }}
              >
                TDA NEWS &<br />UPDATES
              </h2>
              
              <p 
                className="text-gray-300 text-sm md:text-base leading-relaxed mb-6 md:mb-8" 
                style={{ 
                  color: '#d1d5db', 
                  fontSize: '0.875rem',
                  lineHeight: '1.6',
                  marginBottom: '1.5rem',
                  marginLeft:'20px',
                  textAlign: 'left'
                }}
              >
                Stay updated with the latest news, winner stories, and announcements from Tanzania Digital Awards.
              </p>

              {/* View All Button */}
              <Link 
                to="/blog"
                className="inline-flex items-center px-4 py-2 md:px-6 md:py-3 bg-white text-gray-900 rounded-full font-semibold text-xs md:text-sm hover:bg-gray-100 transition-all duration-300 group"
                style={{
                  textDecoration: 'none',
                  display: 'inline-flex',
                  alignItems: 'center',
                  padding: '0.5rem 1rem',
                  backgroundColor: 'white',
                  color: '#111827',
                  marginLeft:'20px',
                  borderRadius: '9999px',
                  fontWeight: '600',
                  fontSize: '0.75rem',
                  gap: '0.5rem',
                  transition: 'all 0.3s ease'
                }}
              >
                VIEW ALL NEWS
                <i className="fa-solid fa-arrow-right group-hover:translate-x-1 transition-transform duration-300"></i>
              </Link>
            </div>

            {/* Right Column - Blog Posts */}
            <div>
              <div 
                className="grid grid-cols-1 md:grid-cols-2 gap-4"
                style={{
                  display: 'grid',
                  gap: '1rem'
                }}
              >
              {posts.map((post) => (
                <Link
                  key={post.id}
                  to={`/blog/${post.slug}`}
                  className="group block"
                  style={{
                    textDecoration: 'none',
                    display: 'block'
                  }}
                >
                  <div 
                    className="bg-gray-800 rounded-lg overflow-hidden hover:bg-gray-700 transition-all duration-300"
                    style={{
                      backgroundColor: '#1f2937',
                      borderRadius: '0.5rem',
                      overflow: 'hidden',
                      transition: 'all 0.3s ease',
                      border: '1px solid rgba(255,255,255,0.1)'
                    }}
                  >
                    {/* Image */}
                    <div 
                      className="relative overflow-hidden"
                      style={{
                        position: 'relative',
                        overflow: 'hidden',
                        height: '100px'
                      }}
                    >
                      <img 
                        src={post.image} 
                        alt={post.title}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                        style={{
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover',
                          transition: 'transform 0.3s ease'
                        }}
                        onError={(e) => {
                          const target = e.target as HTMLImageElement;
                          target.src = '/assets/logo/logo2.png';
                        }}
                      />
                    </div>

                    {/* Content */}
                    <div 
                      className="p-3 md:p-3"
                      style={{ padding: '0.75rem' }}
                    >
                      {/* Date */}
                      <span 
                        className="text-gray-400 text-xs block mb-2"
                        style={{
                          color: '#9ca3af',
                          fontSize: '0.75rem',
                          display: 'block',
                          marginBottom: '0.5rem'
                        }}
                      >
                        {post.date}
                      </span>

                      {/* Title */}
                      <h3 
                        className="text-white text-xs md:text-sm font-bold leading-tight group-hover:text-orange-400 transition-colors mb-2"
                        style={{
                          color: 'white',
                          fontSize: '0.75rem',
                          fontWeight: '700',
                          lineHeight: '1.3',
                          marginBottom: '0.5rem',
                          transition: 'color 0.3s ease',
                          display: '-webkit-box',
                          WebkitLineClamp: 3,
                          WebkitBoxOrient: 'vertical',
                          overflow: 'hidden'
                        }}
                      >
                        {post.title}
                      </h3>

                      {/* Read More Link */}
                      <div 
                        className="inline-flex items-center text-orange-400 font-medium text-xs group-hover:gap-2 transition-all"
                        style={{
                          display: 'inline-flex',
                          alignItems: 'center',
                          color: '#ffba17',
                          fontWeight: '500',
                          fontSize: '0.75rem',
                          gap: '0.25rem',
                          transition: 'gap 0.3s ease'
                        }}
                      >
                        <span>Read More</span>
                        <i className="fa-solid fa-arrow-right"></i>
                      </div>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
      </div>

      {/* Bottom CTA Section */}
      <div 
        className="container mx-auto px-4 mt-12 md:mt-20 relative z-10 flex justify-center"
        style={{ maxWidth: '1400px', marginTop: '3rem', position: 'relative', zIndex: 10, display: 'flex', justifyContent: 'center' }}
      >
        <div 
          className="relative rounded-2xl overflow-hidden bg-white shadow-2xl w-full max-w-6xl"
          style={{
            position: 'relative',
            borderRadius: '1rem',
            overflow: 'hidden',
            backgroundColor: 'white',
            boxShadow: '0 25px 50px rgba(0,0,0,0.15)',
            width: '100%',
            maxWidth: '72rem',
            minHeight: '300px'
          }}
        >
          {/* Left Half - Image */}
          <div 
            className="absolute left-0 top-0 bottom-0 w-1/2 md:w-1/2"
            style={{
              position: 'absolute',
              left: '0',
              top: '0',
              bottom: '0',
              width: '50%',
              overflow: 'hidden'
            }}
          >
            <img 
              src="/assets/posters/carousel1.jpg" 
              alt="Tanzania Digital Awards Event"
              className="w-full h-full object-cover"
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover'
              }}
            />
          </div>

          {/* Right Half - Content */}
          <div 
            className="absolute right-0 top-0 bottom-0 w-1/2 md:w-1/2 p-4 md:p-8 flex flex-col justify-center text-left bg-white"
            style={{
              position: 'absolute',
              right: '0',
              top: '0',
              bottom: '0',
              width: '50%',
              padding: '1rem',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              textAlign: 'left',
              backgroundColor: 'white'
            }}
          >
              <h3 
                className="text-xl md:text-3xl lg:text-4xl font-bold text-gray-900 mb-4 md:mb-6"
                style={{
                  fontSize: 'clamp(1.25rem, 2.5vw, 2.25rem)',
                  fontWeight: '700',
                  color: '#111827',
                  marginBottom: '1rem',
                  lineHeight: '1.3',
                  textAlign: 'left'
                }}
              >
                BE PART OF
                <br />
                <span style={{ fontStyle: 'bold', fontWeight: '400', color: '#ffba17' }}>DIGITAL EXCELLENCE</span>
              </h3>

              <p 
                className="text-gray-600 text-sm md:text-base mb-6 md:mb-8"
                style={{
                  color: '#6b7280',
                  fontSize: '0.875rem',
                  marginBottom: '1.5rem',
                  lineHeight: '1.6',
                  textAlign: 'left'
                }}
              >
                Join Tanzania's premier platform celebrating innovation and digital transformation.
              </p>

              <Link 
                to="/vote/"
                className="inline-flex items-center px-3 py-2 md:px-4 md:py-2 bg-black text-white rounded-full font-medium text-xs md:text-sm hover:bg-gray-800 transition-all duration-300 group shadow-md"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  padding: '0.5rem 0.75rem',
                  width: 'auto',
                  backgroundColor: '#000000',
                  color: 'white',
                  borderRadius: '9999px',
                  fontWeight: '500',
                  fontSize: '0.75rem',
                  textDecoration: 'none',
                  transition: 'all 0.3s ease',
                  gap: '0.375rem',
                  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
                  textAlign: 'center',
                  whiteSpace: 'nowrap'
                }}
              >
                NOMINATE NOW
                <i className="fa-solid fa-arrow-right group-hover:translate-x-1 transition-transform duration-300"></i>
              </Link>
            </div>
        </div>
      </div>
    </section>
  );
};

export default BlogSection;
